import { Trans } from 'react-i18next'
import agustin from '../../assets/images/revolucion/agustin_baragiola.jpeg'
// import agustin_baragiolax2 from "../../assets/images/revolucion/agustin_baragiolax2.jpg";

const Revolucion = () => {
  return (
    <div className="revolucion">
      <div className="container col-md-7" data-aos="fade">
        <div className="revolucion__image">
          <img src={agustin} alt="Agustin Baragiola"></img>
        </div>
        <div className="revolucion__title">
          <h3>
            <Trans i18nKey="revolucion.title" />
          </h3>
          <p className="revolucion__owner">
            <p className="m-0">AGUSTÍN BARAGIOLA</p>
            <p>CHEF & OWNER</p>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Revolucion
